import React from 'react'
import {
    FlatList,
    Dimensions,
    TouchableOpacity
} from 'react-native'
import { useHeaderHeight } from '@react-navigation/stack'
import { Box, VStack, HStack, Text, Icon } from 'native-base'
import { MaterialCommunityIcons, AntDesign } from '@expo/vector-icons'
import moment from 'moment'

export default function ReservationList(props) {
    const headerHeight = useHeaderHeight();
    const { t, reservations } = props

    const renderReservationsView = (object) => {
        const { item } = object
        const { _id, orderId, reservations, createdAt, contact } = item
        const { quantity, status } = reservations
        const { name, phoneNumber } = contact
        const { options, product, time } = reservations.reservation
        const option = options.find((f) => { return f._id == reservations.option })
        console.log(item)
        return (
            <TouchableOpacity onPress={() => props.onOrderPress(_id)}>
                <VStack w={'100%'} p={2}>
                    <HStack justifyContent={'space-between'}>
                        <Text p={1} fontSize={'xs'}>{t('orderNumber', { orderId: orderId })}</Text>
                        <Text p={1} fontSize={'xs'}>{t(status)}</Text>
                    </HStack>
                    <Text p={1} fontSize={'xs'}>{t('orderCreatedAt', { date: moment(createdAt).format('YYYY-MM-DD') })}</Text>
                    <VStack>
                        <Text p={1} fontSize={'xs'}>{product.name}</Text>
                        <Text p={1} fontSize={'xs'}>{`${t('option')}: ${option.name}`}</Text>
                        <Text p={1} fontSize={'xs'}>{`${t('quantity')}: ${quantity}`}</Text>
                        <HStack>
                            <HStack px={2}>
                                <Icon name={'clock-outline'} as={MaterialCommunityIcons} size={'xs'} />
                                <Text fontSize={'xs'}>{moment(time).format('HH:mm')}</Text>
                            </HStack>
                            <HStack px={2}>
                                <Icon name={'user'} as={AntDesign} size={'xs'} />
                                <Text fontSize={'xs'}>{`${name} ${phoneNumber}`}</Text>
                            </HStack>
                        </HStack>
                    </VStack>
                </VStack>
            </TouchableOpacity>
        )
    }

    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} w='100%' p={2}>
            <FlatList
                ItemSeparatorComponent={() => {
                    return (
                        <Box
                            borderBottomWidth={1}
                            borderBottomColor={'gray.200'}
                        />
                    )
                }}
                onEndReached={() => props.onEndReached()}
                data={reservations}
                renderItem={(object) => renderReservationsView(object)}
                keyExtractor={(item, index) => index.toString()}
            />
        </Box>
    )
}
